export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_RESET = "UPDATE_PROFILE_RESET";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const UPDATE_JOBSTATUS_REQUEST = "UPDATE_JOBSTATUS_REQUEST";
export const UPDATE_JOBSTATUS_SUCCESS = "UPDATE_JOBSTATUS_SUCCESS";
export const UPDATE_JOBSTATUS_RESET = "UPDATE_JOBSTATUS_RESET";
export const UPDATE_JOBSTATUS_FAIL = "UPDATE_JOBSTATUS_FAIL";

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_RESET = "UPDATE_PASSWORD_RESET";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const ALL_USERS_REQUEST = "ALL_USERS_REQUEST";
export const ALL_USERS_SUCCESS = "ALL_USERS_SUCCESS";
export const ALL_USERS_FAIL = "ALL_USERS_FAIL";

export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_RESET = "UPDATE_USER_RESET";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const DELETE_USER_RESET = "DELETE_USER_RESET";

export const DELETE_JOB_REQUEST = "DELETE_JOB_REQUEST";
export const DELETE_JOB_SUCCESS = "DELETE_JOB_SUCCESS";
export const DELETE_JOB_FAIL = "DELETE_JOB_FAIL";
export const DELETE_JOB_RESET = "DELETE_JOB_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const CREATE_JOB_FAIL = "CREATE_JOB_FAIL";
export const CREATE_JOB_SUCCESS = "CREATE_JOB_SUCCESS";
export const CREATE_JOB_REQUEST = "CREATE_JOB_REQUEST";

export const CV_UPLOADED_FAIL = "CV_UPLOADED_FAIL";
export const CV_UPLOADED_SUCCESS = "CV_UPLOADED_SUCCESS";
export const CV_UPLOADED_REQUEST = "CV_UPLOADED_REQUEST";

export const JOBS_DETAILS_REQUEST = "JOBS_DETAILS_REQUEST";
export const JOBS_DETAILS_SUCCESS = "JOBS_DETAILS_SUCCESS";
export const JOBS_DETAILS_FAIL = "JOBS_DETAILS_FAIL";

export const SINGLE_JOB_DETAILS_REQUEST = "SINGLE_JOB_DETAILS_REQUEST";
export const SINGLE_JOB_DETAILS_SUCCESS = "SINGLE_JOB_DETAILS_SUCCESS";
export const SINGLE_JOB_DETAILS_FAIL = "SINGLE_JOB_DETAILS_FAIL";

export const ADD_CANDIDATE_REQUEST = "ADD_CANDIDATE_REQUEST";
export const ADD_CANDIDATE_SUCCESS = "ADD_CANDIDATE_SUCCESS";
export const ADD_CANDIDATE_FAIL = "ADD_CANDIDATE_FAIL";

export const GET_ALL_CANDIDATES_OF_JOB_REQUEST =
  "GET_ALL_CANDIDATES_OF_JOB_REQUEST";
export const GET_ALL_CANDIDATES_OF_JOB_SUCCESS =
  "GET_ALL_CANDIDATES_OF_JOB_SUCCESS";
export const GET_ALL_CANDIDATES_OF_JOB_FAIL = "GET_ALL_CANDIDATES_OF_JOB_FAIL";

export const GET_ALL_CUSTOMER_OF_CORP_REQUEST =
  "GET_ALL_CUSTOMER_OF_CORP_REQUEST";
export const GET_ALL_CUSTOMER_OF_CORP_SUCCESS =
  "GET_ALL_CUSTOMER_OF_CORP_SUCCESS";
export const GET_ALL_CUSTOMER_OF_CORP_FAIL = "GET_ALL_CUSTOMER_OF_CORP_FAIL";

export const TOGGLE_IS_ON = "TOGGLE_IS_ON";

export const SET_LOGO = "SET_LOGO";

export const NOTIFICATIONS_REQUEST = "NOTIFICATIONS_REQUEST"
export const NOTIFICATIONS_SUCCESS = "NOTIFICATIONS_SUCCESS"
export const NOTIFICATIONS_FAIL = "NOTIFICATIONS_FAIL"

export const TEAM_MEMBERS_REQUEST = "TEAM_MEMBERS_REQUEST"
export const TEAM_MEMBERS_SUCCESS = "TEAM_MEMBERS_SUCCESS"
export const TEAM_MEMBERS_FAIL = "TEAM_MEMBERS_FAIL"
